import { createSlice } from "@reduxjs/toolkit";
const initialState = {
 // keep the key only if Colum is present in the table
 // keep true to show the column else false to hide 
  data: {
    // projectTitle: true,
    // projectStatus: true,
    phases:true,
    activity:true,
    tasks:true,
    issues: true,
    plannedStartDate: true,
    plannedEndDate: true,
    group: true,
    createdAt: true,
    createdByUserName: true,
    budgetName: false,
    resourceHeads: false,
    siteName: false,
    rateCardTitle: false,    
    calendarTitle: false,

  },
};

export const AllProjectsListViewTableColumnsConfigSlice = createSlice({
  name: "allProjectsListViewTableColumnsConfig",
  initialState,
  reducers: {
    updateAllProjectsListViewTableColumnsConfig(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    resetAllProjectsListViewTableColumnsConfig(state) {
      state.data = initialState.data;
    },
  },
});

export const {
  updateAllProjectsListViewTableColumnsConfig,
  resetAllProjectsListViewTableColumnsConfig,
} = AllProjectsListViewTableColumnsConfigSlice.actions;

export default AllProjectsListViewTableColumnsConfigSlice.reducer;
